import { Component, OnInit } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';

@Component({
    selector: 'app-contacts',
    templateUrl: './contacts.component.html',
    styles: [],
    standalone: false
})
export class ContactsComponent implements OnInit {
  ngOnInit(): void {}
}
